import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "consumer_refund_drawer",
  class: "bg-body",
  "data-kt-drawer": "true",
  "data-kt-drawer-name": "explore",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-width": "{default:'400px', 'lg': '475px'}",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#consumer_refund_drawer_toggle",
  "data-kt-drawer-close": "#consumer_refund_drawer_close"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card shadow-none w-100" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card card-flush pt-0 py-4 flex-row-fluid" }, " hello ")
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}